"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeJSONModelFromQueryString = exports.AuditLogPageModelProvider = exports.useAuditLogPageModelContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const query_string_1 = __importDefault(require("query-string"));
const react_router_dom_1 = require("react-router-dom");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const AuditLogJSONModel_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogJSONModel");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const STATE_QUERY_KEY = "state";
const PageModelContext = React.createContext(undefined);
const useAuditLogPageModelContext = () => {
    const context = React.useContext(PageModelContext);
    if (!context) {
        throw new Error("useAuditLogPageModelContext must be used within a AuditLogPageModelContext.Provider");
    }
    return context;
};
exports.useAuditLogPageModelContext = useAuditLogPageModelContext;
const AuditLogPageModelProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [pageModelFormState, setPageModelFormState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), (0, exports.deserializeJSONModelFromQueryString)(location.search).serialize());
    ////////////////////////////////////////////////
    // Update page model on page URL change
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        if (isMounted()) {
            const jsonModel = (0, exports.deserializeJSONModelFromQueryString)(location.search);
            setPageModelFormState(jsonModel.serialize());
        }
    }, [location.search, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Get Form JSON Model
    ////////////////////////////////////////////////
    const getFormJSONModel = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        return new AuditLogJSONModel_1.AuditLogJSONModel(pageModelFormState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On KeyFilter Changed
    ////////////////////////////////////////////////
    const onKeyFilterChanged = (0, use_custom_compare_1.useCustomCompareCallback)((key) => {
        const jsonModel = new AuditLogJSONModel_1.AuditLogJSONModel(pageModelFormState);
        jsonModel.getKeyFilter().setValue(key);
        const serializedState = jsonModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On ValueFilter Changed
    ////////////////////////////////////////////////
    const onValueFilterChanged = (0, use_custom_compare_1.useCustomCompareCallback)((value) => {
        const jsonModel = new AuditLogJSONModel_1.AuditLogJSONModel(pageModelFormState);
        jsonModel.getValueFilter().setValue(value);
        const serializedState = jsonModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On TimeFilter Changed
    ////////////////////////////////////////////////
    const onTimeFilterChanged = (0, use_custom_compare_1.useCustomCompareCallback)((timeMillis) => {
        const jsonModel = new AuditLogJSONModel_1.AuditLogJSONModel(pageModelFormState);
        jsonModel.getTimeFilter().setValue(timeMillis);
        const serializedState = jsonModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Order Changed
    ////////////////////////////////////////////////
    const onOrderChanged = (0, use_custom_compare_1.useCustomCompareCallback)((order) => {
        const jsonModel = new AuditLogJSONModel_1.AuditLogJSONModel(pageModelFormState);
        jsonModel.getOrder().setValue(order);
        const serializedState = jsonModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Show action
    ////////////////////////////////////////////////
    const show = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        if (isMounted()) {
            //model from location query
            const modelFromLocationQuery = (0, exports.deserializeJSONModelFromQueryString)(location.search);
            //passed model from UI
            const jsonModel = new AuditLogJSONModel_1.AuditLogJSONModel(pageModelFormState);
            //compare if there are differences
            const isEqualState = lodash_1.default.isEqual(modelFromLocationQuery.serialize(), jsonModel.serialize());
            //bump sequence to redraw UI
            jsonModel.getSequenceJSONModel().bumpValue();
            const serializedState = AuditLogJSONModel_1.AuditLogJSONModel.makeModelStateClean(jsonModel.serialize());
            //generate new URL
            const newUrl = AppRouter_1.PathGenerator.project(props.projectApiKey, "auditLog", serializedState);
            if (isEqualState) {
                history.replace(newUrl);
            }
            else {
                history.push(newUrl);
            }
        }
    }, [pageModelFormState, location.search, isMounted, props.projectApiKey], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Return value
    ////////////////////////////////////////////////
    const pageModelStateFns = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        getFormJSONModel,
        show,
        onKeyFilterChanged,
        onValueFilterChanged,
        onTimeFilterChanged,
        onOrderChanged,
    }), [getFormJSONModel, show, onKeyFilterChanged, onValueFilterChanged, onTimeFilterChanged, onOrderChanged], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        pageModelFormState,
        pageModelStateFns,
    }), [
        pageModelFormState,
        pageModelStateFns,
    ], lodash_1.default.isEqual);
    return React.createElement(PageModelContext.Provider, { value: value }, props.children);
};
exports.AuditLogPageModelProvider = AuditLogPageModelProvider;
const deserializeJSONModelFromQueryString = (query) => {
    const queryParams = query_string_1.default.parse(query);
    const modelStateSerialized = queryParams[STATE_QUERY_KEY];
    const jsonModel = new AuditLogJSONModel_1.AuditLogJSONModel();
    jsonModel.overwriteFromSerializedStateString(modelStateSerialized);
    return jsonModel;
};
exports.deserializeJSONModelFromQueryString = deserializeJSONModelFromQueryString;
